import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import '../../../assets/styles/NM.css'
import { useNMContext } from '../../../services/contexts/NMContext';
import ToastPage from '../../includes/ToastPage';
import { Link } from 'react-router-dom';
import { useHistory, useParams } from 'react-router';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';
import { getScheduleEmailBroadcast, scheduleEmailBroadcast, sendEmailBroadcast } from '../../../services/apis/notificationManagement/NMAPI';
import DeleteModalPage from '../../includes/DeleteModalPage';
import { get } from 'http';

export default function EmailBroadcastPage() {

    const { setWhatsappTemplate, setEmailTemplate, whatsappBroadcastHistoryDetail, getScheduledBrodcast, broadCastHistory, setbroadCastHistory, jobType, setJobType } = useNMContext()
    const { setCurrModule, setShowSuccess, allowedFunc, token, logout, setLoginError, setShowDelete } = useLogin()
    const { getCompanyList } = useBuyOrderContext();

    const [error, setError] = useState("")
    const [broadCastHistoryDetail, setbroadCastHistoryDetail] = useState("")

    const [companyList, setCompanyList] = useState("")
    const [companyId, setCompanyId] = useState("")
    const [mailType, setMailType] = useState("")
    const [clientSelection, setClientSelection] = useState("")
    const [portfolioSize, setPortfolioSize] = useState("")
    const [quantity, setQuantity] = useState("")
    const [price, setPrice] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [mailFrequency, setMailFrequency] = useState("")
    const [deleteId, setDeleteId] = useState({})


    const history = useHistory()

    useEffect(() => {
        try {
            setCurrModule(configs.modules.jobScheduler)
            if (allowedFunc.includes(configs.functionList['job_scheduler:job_scheduler'])) {
                (async () => {
                    getScheduledBrodcast(jobType)
                    let response = await getCompanyList()
                    if (response.success) {
                        setCompanyList(response.data)
                    } else {

                    }
                })()
            } else {
                return history.goBack()
            }
        } catch (error) {
            console.error(error)
        }

    }, [])


    // update mobile template
    async function updateTemplate() {
        try {
            document.getElementById("whatsappBtn").classList.toggle("d-none")
            document.getElementById("whatsappBtnLoader").classList.toggle("d-none")

            let response = await scheduleEmailBroadcast(token, [clientSelection], mailType, companyId, portfolioSize, startDate, endDate, mailFrequency, quantity, price);
            if (response && response.status === 200) {
                setShowSuccess(true);
                getScheduledBrodcast(jobType);
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            } else {
                setError(response.data.error)
            }
        } catch (error) {
            console.error(error);
        } finally {
            document.getElementById("whatsappBtn").classList.toggle("d-none")
            document.getElementById("whatsappBtnLoader").classList.toggle("d-none")
        }
    }

    // update mobile template
    async function sendDirectEmailBroadcast() {
        try {
            document.getElementById("sendBrodcast").classList.toggle("d-none")
            document.getElementById("sendBrodcastLoader").classList.toggle("d-none")

            let response = await sendEmailBroadcast(token, [clientSelection], mailType, companyId, portfolioSize, startDate, endDate, mailFrequency, quantity, price);
            if (response && response.status === 200) {
                setShowSuccess(true);
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            } else {
                setError(response.data.error)
            }
        } catch (error) {
            console.error(error);
        } finally {
            document.getElementById("sendBrodcast").classList.toggle("d-none")
            document.getElementById("sendBrodcastLoader").classList.toggle("d-none")
        }
    }

    async function getWhatsappHistoryDetail(id) {
        try {
            setbroadCastHistoryDetail("")
            let response = await whatsappBroadcastHistoryDetail(id)
            if (response && response.success) {
                setbroadCastHistoryDetail(response.data)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const historyColumns = [{ field: "id", headerName: "Schedule ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
    { field: "company_name", headerName: "Asset Name", minWidth: 250, flex: 0.3, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.company_name, valueGetter: (params) => params.row.payload.company_name },
    { field: "mail_type", headerName: "Mail Type", minWidth: 150, flex: 0.3, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.mail_type, valueGetter: (params) => params.row.payload.mail_type },
    { field: "user_filters", headerName: "Client Selection", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.user_filters && cellValues.row.payload.user_filters.length > 0 ? cellValues.row.payload.user_filters.join(",") : cellValues.row.payload.user_filters, valueGetter: (params) => params.row.payload.user_filters && params.row.payload.user_filters.length > 0 ? params.row.payload.user_filters.join(",") : params.row.payload.user_filters },
    { field: "portfolio_size", headerName: "Portfolio Size", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.portfolio_size, valueGetter: (params) => params.row.payload.portfolio_size },
    { field: "quantity", headerName: "Quantity", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.quantity, valueGetter: (params) => params.row.payload.quantity },
    { field: "price", headerName: "Price", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.price, valueGetter: (params) => params.row.payload.price },
    { field: "start_date", headerName: "Start Date", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.start_date, valueGetter: (params) => params.row.payload.start_date },
    { field: "End Date", headerName: "End Date", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.end_date, valueGetter: (params) => params.row.payload.end_date },
    { field: "Frequency", headerName: "Frequency", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.payload.frequency, valueGetter: (params) => params.row.payload.frequency },
    { field: "total_runs", headerName: "Total Runs", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.total_runs, valueGetter: (params) => params.row.total_runs },
    { field: "completed_runs", headerName: "Completed Runs", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.completed_runs, valueGetter: (params) => params.row.completed_runs },
    { field: "timestamp", headerName: "Created Date", minWidth: 100, flex: 0.5, cellClassName: "break-text", renderCell: (cellValues) => cellValues.row.timestamp, valueGetter: (params) => params.row.timestamp },
    // {
    //     field: "details", headerName: "View Details", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
    //         return <a href="#" className="custom-link text-primary" onClick={(e) => {
    //             e.preventDefault()
    //             getScheduledBrodcast(jobType, )
    //         }}>View Details</a>
    //     }
    // },
    jobType === "pending" ? {
        field: "email_template", headerName: "Update Email Template", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <Link to="/emailTemplateManagement" className="custom-link text-primary" onClick={(e) => {
                // e.preventDefault()
                setEmailTemplate({ scheduler_id: cellValues.row.id })
            }}>Update Email Template</Link>
        }
    } : "",
    jobType === "pending" ? {
        field: "whatsapp_template", headerName: "Update WhatsApp Template", minWidth: 100, flex: 0.2, cellClassName: "break-text f-12", filterable: false, renderCell: (cellValues) => {
            return <Link to="/whatsappTemplateManagement" className="custom-link text-primary" onClick={(e) => {
                // e.preventDefault()
                setWhatsappTemplate({ scheduler_id: cellValues.row.id })
            }}>Update WhatsApp Template</Link>
        }
    } : "",
    jobType === "pending" ? {
        field: "delete", headerName: " ", minWidth: 65, flex: 0.1, cellClassName: "break-text", cellClassName: "text-danger", renderCell: (params) => {
            return <a href="#" className="custom-link text-danger" onClick={(e) => {
                e.preventDefault()
                setDeleteId({
                    "category": configs.modules.jobScheduler,
                    "type": "Scheduled Job",
                    "name": params.row.name,
                    "id": params.row.id,
                    data: params.row
                })
                setShowDelete(true)
            }}>Delete</a>
        }
    } : ""
    ]

    const historyDetailColumns = [{ field: "id", headerName: "Detail ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
    { field: "mobile", headerName: "Mobile No.", minWidth: 100, flex: 0.3, cellClassName: "break-text" },
    {
        field: "is_processed", headerName: "Processing Status", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return params.row.is_processed === 1 ? "Processed" : "Pending"
        }, valueGetter: (params) => params.row.is_processed === 1 ? "Processed" : "Pending"
    },
    {
        field: "is_sent", headerName: "Status", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return params.row.is_sent === 1 ? "Successful" : "Failed"
        }, valueGetter: (params) => params.row.is_sent === 1 ? "Successful" : "Failed"
    },
    { field: "error", headerName: "Failure Reason", minWidth: 300, flex: 0.5, cellClassName: "break-text" },
    { field: "sent_on", headerName: "Sent Timestamp", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    ]


    // notification management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='whatsappBroadcastContainer' className="nm-container">
                    <div style={{ width: "100%" }}>
                        <div className="row d-flex align-items-center mt-2 ml-2 mb-2 mr-3">
                            <div className="col-md-9 text-left">
                                <p className="h4 text-custom-grey">Schedule Broadcast</p>
                            </div>
                        </div>
                        <div className="mb-4 mr-4 nm-template">
                            <p className="text-primary h6 pl-0 ml-0">Broadcast Filters</p>
                            <div className="pr-3">
                                <form action="">
                                    <div className='row m-0 p-0'>
                                        <div className='col-md-6 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Select Asset</label>
                                                {companyList ? <Autocomplete
                                                    className="f-12"
                                                    id="companyIP"
                                                    placeholder="Compnay Name"
                                                    getOptionLabel={option => option.name}
                                                    onChange={(e, value) => setCompanyId(value ? value.id : "")}
                                                    options={companyList}
                                                    value={companyList.find(item => item.id === companyId) || ""}
                                                    renderInput={(params) => <TextField {...params} placeholder="Asset Name" className="f-12" />}
                                                /> : null}
                                            </div>
                                        </div>
                                        <div className='col-md-6 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Mail Type</label>
                                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={mailType} onChange={(e) => {
                                                    setMailType(e.target.value)
                                                    setError("")
                                                }}>
                                                    <option className='f-12' value="" disabled> Select Mail Type </option>
                                                    {companyId ?
                                                        <>
                                                            <option className='f-12' value="BUY"> Buy </option>
                                                            <option className='f-12' value="SELL"> Sell </option>
                                                            <option className='f-12' value="MANDATE"> Mandate </option>
                                                        </> : null}
                                                    <option className='f-12' value="UPDATE"> Update </option>
                                                    <option className='f-12' value="INVESTMENT_OPPORTUNITY"> Investment Opportunity </option>
                                                    <option className='f-12' value="NEW_BASKET"> New Basket </option>
                                                    <option className='f-12' value="PRO_OFFER"> Pro Offer </option>
                                                    <option className='f-12' value="PRICE_ALERT"> Price Alert </option>

                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-md-6 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Client Selection</label>
                                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={clientSelection} onChange={(e) => {
                                                    setClientSelection(e.target.value)
                                                    setError("")
                                                }}>
                                                    <option className='f-12' value="" disabled> Select Client Type </option>
                                                    {companyId ?
                                                        <>
                                                            <option className='f-12' value="BUY"> Buy </option>
                                                            <option className='f-12' value="SELL"> Sell </option>
                                                            <option className='f-12' value="MANDATE_UNSUCCESSFUL"> Mandate Unsuccessful</option>
                                                            <option className='f-12' value="HOLDINGS"> Holdings </option>
                                                            <option className='f-12' value="ORDER_INSIGHTS"> Order Insights </option>
                                                        </> : null}
                                                    <option className='f-12' value="CUSTOMER_ACTION"> Customer Action </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_KYC_NOT_INITIATED"> KYC Not Initiated </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_NO_ORDER_GENERATED"> No Order Generated </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_ATLEAST_ONE_ORDER"> Atleast One Order </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_KYC_PENDING"> KYC Pending </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_KYC_REJECTED"> KYC Rejected </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_KYC_APPROVED"> KYC Approved </option>
                                                    <option className='f-12' value="CUSTOMER_STATISTICS_ATLEAST_ONE_BUY_ORDER"> Atleast One Buy Order </option>
                                                    <option className='f-12' value="PRO_USERS"> Pro Users </option>
                                                    <option className='f-12' value="DISTRIBUTORS"> Distributors </option>

                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-md-6 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Portfolio Size</label>
                                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={portfolioSize} onChange={(e) => {
                                                    setPortfolioSize(e.target.value)
                                                    setError("")
                                                }}>
                                                    <option className='f-12' value="" disabled> Select Portfolio Size </option>
                                                    <option className='f-12' value="LESS_THAN_10_LAKH"> &lt; 10 LAKH </option>
                                                    <option className='f-12' value="BETWEEN_10_AND_50_LAKH"> 10 - 50 LAKH </option>
                                                    <option className='f-12' value="GREATER_THAN_50_LAKH"> &gt; 50 LAKH</option>
                                                </select>
                                            </div>
                                        </div>
                                        {companyId ?
                                            <>
                                                <div className='col-md-6 col-12 m-0'>
                                                    <div className="form-group">
                                                        <label htmlFor="whatsapp_utm">Quantity</label>
                                                        <input type="number" id="" className="form-control f-10" placeholder="Quantity" value={quantity} onChange={(e) => {
                                                            setQuantity(e.target.value)
                                                            setError("")
                                                        }} />
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-12 m-0'>
                                                    <div className="form-group">
                                                        <label htmlFor="whatsapp_utm">Price</label>
                                                        <input type="number" id="" className="form-control f-10" placeholder="Price" value={price} onChange={(e) => {
                                                            setPrice(e.target.value)
                                                            setError("")
                                                        }} />
                                                    </div>
                                                </div>
                                            </> : null}
                                        <div className='col-md-4 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Start Date</label>
                                                <input type="date" id="" className="form-control f-10" placeholder="Start Date" value={startDate} required onChange={(e) => {
                                                    setStartDate(e.target.value)
                                                    setError("")
                                                }} />
                                            </div>
                                        </div>
                                        <div className='col-md-4 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">End Date</label>
                                                <input type="date" id="" className="form-control f-10" placeholder="End Date" value={endDate} required onChange={(e) => {
                                                    setEndDate(e.target.value)
                                                    setError("")
                                                }} />
                                            </div>
                                        </div>
                                        <div className='col-md-4 col-12 m-0'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Mail Frequency</label>
                                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={mailFrequency} required onChange={(e) => {
                                                    setMailFrequency(e.target.value)
                                                    setError("")
                                                }}>
                                                    <option className='f-12' value="" disabled> Select Mail Frequency </option>
                                                    <option className='f-12' value="DAILY"> Daily </option>
                                                    <option className='f-12' value="WEEKLY"> Weekly </option>
                                                    <option className='f-12' value="MONTHLY"> Monthly</option>
                                                    <option className='f-12' value="YEARLY"> Yearly</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-check p-0">
                                        <p className="text-danger" id="templateError">{error}</p>
                                    </div>
                                    <div className="form-row">
                                        <div className="col-12 d-flex justify-content-center">
                                            <button id="whatsappBtn" type="submit" className="btn btn-primary" onClick={(e) => {
                                                e.preventDefault()
                                                updateTemplate()
                                            }}>Schedule Broadcast</button>
                                            <div id="whatsappBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                                            {allowedFunc.includes(configs.functionList['email_broadcast:email_broadcast']) ?
                                                <>
                                                    <button id="sendBrodcast" type="submit" className="btn btn-primary ml-2" onClick={(e) => {
                                                        e.preventDefault()
                                                        sendDirectEmailBroadcast()
                                                    }}>Send Email Broadcast</button>
                                                    <div id="sendBrodcastLoader" className='animBtn d-none ml-2'><div className='gSignIn-Anim'></div></div>
                                                </> : null}
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {broadCastHistory ?
                                <div className="h-50 my-5">
                                    <div className='row m-0 p-0'>
                                        <div className='col-6 m-0 p-0'>
                                            <p className="h5 text-custom-grey text-capitalize">{jobType} Jobs</p>
                                        </div>
                                        <div className='col-6 m-0 text-right'>
                                            <div className="form-group">
                                                <label htmlFor="whatsapp_utm">Select Job Type</label>
                                                <select name="" id="" className="col-12 py-1 px-2 border rounded f-12" value={jobType} required onChange={(e) => {
                                                    setJobType(e.target.value)
                                                    getScheduledBrodcast(e.target.value)
                                                }}>
                                                    <option className='f-12' value=""> All </option>
                                                    <option className='f-12' value="completed"> Completed </option>
                                                    <option className='f-12' value="pending"> Pending </option>
                                                    <option className='f-12' value="deleted"> Deleted</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <DataGrid
                                        rows={broadCastHistory}
                                        headerHeight={40}
                                        rowHeight={30}
                                        columns={historyColumns}
                                        resizable={true}
                                        autoPageSize
                                        pagination
                                        components={{
                                            Toolbar: GridToolbar,
                                        }} />
                                </div>
                                : null}

                            {broadCastHistoryDetail ?
                                <div className="h-50 mt-5">
                                    <p className="h5 text-custom-grey">WhatsApp Broadcast Delivery Report</p>
                                    <DataGrid
                                        rows={broadCastHistoryDetail}
                                        headerHeight={40}
                                        rowHeight={30}
                                        columns={historyDetailColumns}
                                        resizable={true}
                                        autoPageSize
                                        pagination
                                        components={{
                                            Toolbar: GridToolbar,
                                        }} />
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
                <ToastPage />
                <DeleteModalPage {...deleteId} />
            </div>
        </>
    )
}